module.exports = __webpack_public_path__ + "img/N5.acb7bce6.svg";